var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyFoundryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9256 0L0 29.9251L29.9256 59.8507L59.8504 29.9251L29.9256 0ZM29.9256 55.2466L4.60412 29.9251L29.9256 4.60365L55.2472 29.9251L29.9256 55.2466Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2166 19.837L24.781 24.0518L24.0787 22.4333L21.3909 25.7014V34.4976L24.0787 37.7659V28.2971L25.056 30.4661L26.2166 26.8925V40.3621L28.9043 43.6302L28.935 16.5688L26.2166 19.837Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6273 31.4433H36.4986V28.7557H33.6273V24.0518L36.4986 27.5339L38.2695 25.457L30.9396 16.5688V43.6302L33.6273 40.3621V31.4433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFoundryLogo);
export default __webpack_public_path__ + "static/media/my-foundry-logo.3dd956f2f6fdc75194214a15c0ccb943.svg";
export { ForwardRef as ReactComponent };